<template>
  <div class="icon">
    <Start
      v-if="direction === 'CIRCLE'"
      :iconColor="color ? color : undefined"
      :width="width ? width : undefined"
    />
    <Depart
      v-else-if="direction === 'DEPART'"
      :iconColor="color ? color : undefined"
      :width="width ? width : undefined"
    />
    <SlightlyLeft
      v-else-if="direction === 'SLIGHTLY_LEFT'"
      :iconColor="color ? color : undefined"
      :width="width ? width : undefined"
    />
    <SlightlyRight
      v-else-if="direction === 'SLIGHTLY_RIGHT'"
      :iconColor="color ? color : undefined"
      :width="width ? width : undefined"
    />
    <Left
      v-else-if="
        direction === 'LEFT' ||
        direction === 'HARD_LEFT'
      "
      :iconColor="color ? color : undefined"
      :width="width ? width : undefined"
    />
    <Right
      v-else-if="
        direction === 'RIGHT' ||
          direction === 'HARD_RIGHT'
      "
      :iconColor="color ? color : undefined"
      :width="width ? width : undefined"
    />
    <UturnLeft
      v-else-if="
        direction === 'UTURN_LEFT'
      "
      :iconColor="color ? color : undefined"
      :width="width ? width : undefined"
    />
    <UturnRight
      v-else-if="
        direction === 'UTURN_RIGHT'
      "
      :iconColor="color ? color : undefined"
      :width="width ? width : undefined"
    />

    <Continue
      v-else
      :iconColor="color ? color : undefined"
      :width="width ? width : undefined"
    />
  </div>
</template>

<script>
import Start from '@/components/Icons/Directions/Circle.vue';
import Continue from '@/components/Icons/Directions/Continue.vue';
import Depart from '@/components/Icons/Directions/Depart.vue';
import Left from '@/components/Icons/Directions/Left.vue';
import Right from '@/components/Icons/Directions/Right.vue';
import SlightlyLeft from '@/components/Icons/Directions/SlightlyLeft.vue';
import SlightlyRight from '@/components/Icons/Directions/SlightlyRight.vue';
import UturnLeft from '@/components/Icons/Directions/UturnLeft.vue';
import UturnRight from '@/components/Icons/Directions/UturnRight.vue';

export default {
  name: 'direction-icon',
  components: {
    Start,
    Depart,
    Continue,
    Left,
    Right,
    SlightlyLeft,
    SlightlyRight,
    UturnLeft,
    UturnRight,
  },
  props: {
    direction: String,
    color: String,
    width: Number,
  },
};
</script>

<style lang="scss" scoped>
.icon {
  min-width: 16px;
}
</style>
